import { z } from 'zod';
import { makeRequired } from '@axiom/types';
import { BaseCandidateOpportunitySchema } from '@axiom/validation';

export const EngagementsViewOptOutSchema = z.object({
  candidateReasonForNo: makeRequired(
    BaseCandidateOpportunitySchema.shape.candidateReasonForNo
  ),
});

export type EngagementsViewOptOut = z.infer<typeof EngagementsViewOptOutSchema>;
